import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useTypedParams } from '@sorare/routing';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { Search } from 'components/team/Search';

import type {
  BaseballTeamCardsQuery,
  BaseballTeamCardsQueryVariables,
} from './__generated__/page.graphql';
import type { PageParams } from './__generated__/routeParams';

const BASEBALL_TEAM_CARD_QUERY = gql`
  query BaseballTeamCardsQuery($slug: String!) {
    team(slug: $slug) {
      slug
      ...BaseballTeamSearch_teamInterface
    }
  }
  ${Search.fragments.team}
` as TypedDocumentNode<BaseballTeamCardsQuery, BaseballTeamCardsQueryVariables>;

const BaseballTeamCards = () => {
  const { slug } = useTypedParams<PageParams>();
  const { data, loading } = useQuery(BASEBALL_TEAM_CARD_QUERY, {
    variables: {
      slug,
    },
  });

  const team = data?.team;

  if (loading) return <LoadingIndicator fullHeight />;
  if (!slug || !team) return null;

  return <Search team={team} />;
};

export default BaseballTeamCards;
